/**
 * copy-text — clipboard write that works in permission-restricted contexts
 * (iframes, non-secure embeds): tries the async Clipboard API, then falls back
 * to a hidden textarea + execCommand. Returns whether the copy succeeded so
 * callers can toast honestly (never a success toast on a failed copy).
 */
export async function copyText(text: string): Promise<boolean> {
  try { await navigator.clipboard.writeText(text); return true; } catch { /* fall through to legacy path */ }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed"; ta.style.top = "0"; ta.style.left = "0"; ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select(); ta.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch { return false; }
}
